import React, { useState } from 'react'
import { Card, CardContent, IconButton, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core'
import blue from '@material-ui/core/colors/blue'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'
import classNames from 'classnames'
import DegreeCard from './DegreeCard'

const useStyles = makeStyles((theme: any) => ({
	container: {
		position: 'relative',
		'&:hover': {
			color: 'darkgrey',
		},
	},
	iconButtonPlay: {
		position: 'absolute',
		opacity: 0,
		left: 24,
		top: 11,
		width: 42,
		height: 42,
		color: 'lightgray',
		transition: 'color 0.25s, opacity 0.25s',
		'&:hover': {
			color: 'darkgrey',
		},
	},
	iconPlay: {
		fontSize: 24,
	},
}))

const initialMenuState = {
	mouseX: null,
	mouseY: null,
}

const DegreesSettings = (props: {
	degrees: any[],
	scaleNotes: string[],
	degree: number,
	onDegreeChange: (degree: number) => void,
	onPlayClick: (degree: number) => void,
	scales: any[],
	onScaleChange: (scale: any) => void
}) => {
	const classes = useStyles()

	const {
		degrees,
		degree,
		scaleNotes,
		onDegreeChange,
		onPlayClick,
		onScaleChange,
		scales
	} = props

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: 42 }}>
			<Typography variant="h4" component="h2" style={{
				marginBottom: 6,
				color: 'white',
				padding: '0 64px 9px 64px',
				borderBottom: '1px solid white',
				fontSize: '1.125rem',
			}}>
				Degrees
			</Typography>
			
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{degrees.map((d, i) => (
					<div style={{ position: 'relative' }}>
						<DegreeCard
							className={classNames('scale-card', { empty: d.empty })}
							// @ts-ignore
							onClick={d.empty ? undefined : (e) => { /*console.log({ onSelectDegree: e.target.classList })*/; e.target.classList.length !== 0 && !e.target.classList.contains('MuiListItem-root') && onDegreeChange(i)}}
							onPlayClick={() => onPlayClick(i)}
							isSelected={degree === i}
							scaleNote={scaleNotes[i]}
							scale={scales[i]}
							degree={d}
							onScaleChange={onScaleChange}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

export default DegreesSettings

// TODO : Shortcuts to select degrees (1, 2, 3, ...)